import * as types from './mutations-types';

export default {
    /**
     * 
     * @param {*} state 
     * @param {*} payload 
     */
    [types.LOGIN](state, response) {}
}